
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/cricket/[slug]/commentary",
      function () {
        return require("private-next-pages/sports/cricket/[slug]/commentary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/cricket/[slug]/commentary"])
      });
    }
  